import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-600px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_5 = { class: "px-7 py-5" }
const _hoisted_6 = { class: "row mb-7" }
const _hoisted_7 = { class: "col-md-6 form-group" }
const _hoisted_8 = { class: "form-label fw-bold" }
const _hoisted_9 = { class: "col-md-6 form-group" }
const _hoisted_10 = { class: "form-label fw-bold" }
const _hoisted_11 = { class: "row mb-7" }
const _hoisted_12 = { class: "col-md-6 form-group" }
const _hoisted_13 = { class: "form-label fw-bold" }
const _hoisted_14 = { class: "col-md-6 form-group" }
const _hoisted_15 = { class: "form-label fw-bold" }
const _hoisted_16 = { class: "row mb-7" }
const _hoisted_17 = { class: "col-md-6 form-group" }
const _hoisted_18 = { class: "form-label fw-bold" }
const _hoisted_19 = { class: "row mb-7" }
const _hoisted_20 = { class: "col-md-6 form-group" }
const _hoisted_21 = { class: "form-label fw-bold" }
const _hoisted_22 = { class: "col-md-6 form-group" }
const _hoisted_23 = { class: "form-label fw-bold" }
const _hoisted_24 = { class: "d-flex justify-content-end" }
const _hoisted_25 = {
  type: "submit",
  class: "btn btn-sm btn-primary",
  "data-kt-menu-dismiss": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("common.filterOptions")), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        onSubmit: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        model: _ctx.formData
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t("proformaInvoice.proformaNo")) + ":", 1),
              _createVNode(_component_el_form_item, {
                prop: "invoice_number",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.invoice_number,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.invoice_number) = $event)),
                    type: "text",
                    placeholder: _ctx.t('common.plsEnter'),
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t("proformaInvoice.dealerNo")) + ":", 1),
              _createVNode(_component_el_form_item, {
                prop: "dealer_number",
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.dealer_number,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.dealer_number) = $event)),
                    type: "text",
                    placeholder: _ctx.t('common.plsEnter'),
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("proformaInvoice.vatId")) + ":", 1),
              _createVNode(_component_el_form_item, {
                prop: "vat_id",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.vat_id,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.vat_id) = $event)),
                    type: "text",
                    placeholder: _ctx.t('common.plsEnter'),
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("shipments.id")) + ":", 1),
              _createVNode(_component_el_form_item, {
                prop: "shipment_id",
                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.shipment_id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.shipment_id) = $event)),
                    type: "text",
                    placeholder: _ctx.t('common.plsEnter'),
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("shipments.trackingNo")) + ":", 1),
              _createVNode(_component_el_form_item, {
                prop: "track_number",
                onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.track_number,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.track_number) = $event)),
                    type: "text",
                    placeholder: _ctx.t('common.plsEnter'),
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("common.createdDateStart")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "created_at_start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    class: "w-100",
                    modelValue: _ctx.formData.created_at_start,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.created_at_start) = $event)),
                    type: "date",
                    placeholder: _ctx.t('common.pickDate')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("common.createdDateEnd")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "created_at_end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    class: "w-100",
                    modelValue: _ctx.formData.created_at_end,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.created_at_end) = $event)),
                    type: "date",
                    placeholder: _ctx.t('common.pickDate')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              type: "reset",
              class: "btn btn-sm btn-light btn-active-light-primary me-2",
              "data-kt-menu-dismiss": "true",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
            }, _toDisplayString(_ctx.t("common.reset")), 1),
            _createElementVNode("button", _hoisted_25, _toDisplayString(_ctx.t("common.apply")), 1)
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}